import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  totalCount: PropTypes.number.isRequired,
  _handlePage: PropTypes.func.isRequired,
}

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pager: {} };
  }

  componentWillMount() {
    // set page if items array isn't empty
    if (this.props.totalCount > 0) {
      this._setPage(this.props.page);
    }
  }

  //for optimization so component doesn't update unless it needs to
  // shouldComponentUpdate(nextProps, nextState) {
  //   if(this.props.totalCount !== nextProps.totalCount || 
  //       this.props.isMobile !== nextProps.isMobile ||
  //       this.props.page !== nextProps.page
  //     ) 
  //   {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    // reset page if items array has changed
    if (this.props.totalCount !== prevProps.totalCount || this.props.splitView !== prevProps.splitView
        // || this.props.page !== prevProps.page
        ) 
    {
      this._setPage(this.props.page);
    } 
  }

  _setPage(page, load) {
    // console.log('_setPage ' + page)
    let pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    // get new pager object for specified page
    pager = this._getPager(this.props.totalCount, page);
    // console.log('pager var returned')

    // update state
    this.setState({ pager: pager });

    // call change page function in parent component
    if(page === 1) {
      this.props._handlePage(0);
    } else {
      this.props._handlePage(page - 1);
    }
  }

  _getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size
    pageSize = pageSize || this.props.pageSize;

    // calculate total pages
    const totalPages = Math.ceil(totalItems / pageSize);
    const splitPageEnd = this.props.splitView ? 4 : 8;

    var startPage, endPage;
    if (totalPages <= splitPageEnd) {
      // less than 8 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      const splitPageSplit = this.props.splitView ? 3 : 5;
      const splitPageDif = this.props.splitView ? 3 : 7;
      const splitPageAdd = this.props.splitView ? 2 : 4;
      const splitPageDif2 = this.props.splitView ? 2 : 4;
      const splitPageAdd2 = this.props.splitView ? 1 : 3;
      // more than 8 (or 4 for splitView) total pages so calculate start and end pages
      if (currentPage <= splitPageSplit) {
          startPage = 1;
          endPage = splitPageEnd;
      } else if (currentPage + splitPageAdd >= totalPages) {
          startPage = totalPages - splitPageDif;
          endPage = totalPages;
      } else {
          startPage = currentPage - splitPageDif2;
          endPage = currentPage + splitPageAdd2;
      }
    }

    // create an array of pages to repeat in the pager map
    const range = (start, end) => (
      Array.from(Array(end - start + 1).keys()).map(i => i + start)
    );

    const pages = range(startPage, endPage);
    const pagerObj = {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      pages: pages
    };
    // console.log(pagerObj)
    return pagerObj;
  }

  render() {
    const pager = this.state.pager;
// console.log('Pagination render ', pager)
    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null;
    }
    
    //DESKTOP
    if(!this.props.isMobile) {
      return (
        <div className="c_pagination-container">
          <ul className="c_ul-pagination u_inline-block">
            <li>
              <a className={pager.currentPage === 1 ? 's_disabled-pag' : ''} onClick={() => this._setPage(pager.currentPage - 1)}>Previous</a>
            </li>
            
            {pager.pages.map((page, i) =>
              <li key={`page-${i + 1}`} className={pager.currentPage === page ? 's_active-pag' : ''}>
                <a onClick={() => this._setPage(page)}>{page}</a>
              </li>
            )}

            <li>
              <a className={pager.currentPage === pager.totalPages ? 's_disabled-pag' : ''} onClick={() => this._setPage(pager.currentPage + 1)}>Next</a>
            </li>
          </ul>
        </div>
      );

    //MOBILE  
    } else {
      return (
        <div className="c_pagination-container u_mg-left-none">
          <ul className="c_ul-pagination u_inline-block">
            <li>
              <a className={pager.currentPage === 1 ? 's_disabled-pag' : ''} onClick={() => this._setPage(pager.currentPage - 1)}>Previous</a>
            </li>
            
            <li className='s_active-pag'>
              <span>Page {pager.currentPage}</span>
            </li>

            <li>
              <a className={pager.currentPage === pager.totalPages ? 's_disabled-pag' : ''} onClick={() => this._setPage(pager.currentPage + 1)}>Next</a>
            </li>
          </ul>
        </div>
      );
    }
  }
}

Pagination.propTypes = propTypes;
export default Pagination;

/*
<li className={pager.currentPage === 1 ? 'disabled' : ''}>
            <a onClick={() => this._setPage(1)}>First</a>
          </li>  
          <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
            <a onClick={() => this._setPage(pager.totalPages)}>Last</a>
          </li>
*/